const TableName = {
students: "regular_students",
studentsType: "student_types",
pteStudents: "pte_students",
demostudents: "demo_students",
teachers: "teachers",
basicExpenses: "basic_expense",
salaryExpenses: "salary_expense",
batches: "batches",
users: "users",
courses: "courses",
paymenyDuration: "payment_durations",
attendance: "attendance",
teacherAttendance: "attendance_teachers",
studentPerformance: "students_performnace",
mockTest: "mock_test",
profile: "profile",
visa: "visa",
fee: "fees_module",
pendingFees: "pending_fees_module",
notes:"notes_data"

}

export default TableName;